import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import { store } from '@/store'

export enum ToolbarDeactivations {
    None = 0,
    ZoomAndRotation = 1 << 0,
    Deletion = 1 << 1,
    Preview = 1 << 2,
    All = ~(~0 << 3)
}

export enum ToolbarUploads {
    None = 0,
    Receivable = 1 << 0,
    Initiated = 1 << 1
}

export interface ToolbarState {
    deactivated: number
    zoom: number
    rotation: number
    center: [number, number]
    error: boolean
    upload: number
}

export type ToolbarInitializePayload = {
    rotation: number,
    zoom: number,
    center: [number, number]
}

@Module({ dynamic: true, store, name: 'toolbar' })
export class Toolbar extends VuexModule implements ToolbarState {

    public deactivated: number = ToolbarDeactivations.ZoomAndRotation | ToolbarDeactivations.Deletion
    public zoom: number = 0.0
    public rotation: number = 0
    public center: [number, number] = [0, 0]
    public error: boolean = false
    public upload: number = ToolbarUploads.None
    public confirmed: boolean = false
    public errorKeys: string[] = []

    @Mutation
    public SET_TOOLBAR_ERROR(hasError: boolean) {
        this.error = hasError
    }

    @Mutation
    public SET_TOOLBAR_UPLOAD(upload: number) {
        this.upload = upload
    }

    @Mutation
    public SET_ZOOM(zoom: number) {
        this.zoom = zoom
    }

    @Mutation
    public OFFSET_ZOOM(offset: number) {
        let zoom = this.zoom + offset
        if (zoom < 0.0) {
            this.zoom = 0.0
        } else if (zoom > 100.0) {
            this.zoom = 100.0
        } else {
            this.zoom = zoom
        }
    }

    @Mutation
    public SET_ROTATION(rotation: number) {
        this.rotation = rotation
    }

    @Mutation
    public OFFSET_ROTATION(offset: number) {
        let rotation = this.rotation + offset
        if (rotation < 0) {
            rotation += 360
        } else if (rotation > 360) {
            rotation -= 360
        }
        this.rotation = rotation
    }

    @Mutation
    public SET_CENTER(center: [number, number]) {
        this.center = center
    }

    @Mutation
    public INITIALIZE_TOOLBAR(payload: ToolbarInitializePayload) {
        this.rotation = payload.rotation
        this.zoom = payload.zoom
        this.center = payload.center
    }

    @Mutation
    public SET_DEACTIVATED(deactivated: number) {
        this.deactivated = deactivated
    }

    @Mutation
    public SET_CONFIRMED(confirmed: boolean) {
        this.confirmed = confirmed
    }

    @Mutation
    public SET_USAGENAME(usagename: string) {
        if (!this.errorKeys.includes(usagename)) {
            this.errorKeys.push(usagename)
        }
    }

    @Mutation
    public UNSET_USAGENAME(usagename: string) {
    let idx = this.errorKeys.indexOf(usagename)
        if (idx !== undefined && idx !== -1) {
            this.errorKeys.splice(idx, 1)
        }
        if (this.errorKeys.length === 0 && this.error === true) {
            this.error = false
        }
    }

    @Action({ commit: 'SET_ZOOM' })
    public SetZoom(zoom: number) {
        return zoom
    }

    @Action({ commit: 'SET_TOOLBAR_ERROR' })
    public SetToolbarError(hasError: boolean) {
        return hasError
    }

    @Action({ commit: 'SET_TOOLBAR_UPLOAD' })
    public SetToolbarUpload(upload: number) {
        return upload
    }

    @Action({ commit: 'OFFSET_ZOOM' })
    public OffsetZoom(offset: number) {
        return offset
    }

    @Action({ commit: 'SET_ROTATION' })
    public SetRotation(rotation: number) {
        return rotation
    }

    @Action({ commit: 'OFFSET_ROTATION' })
    public OffsetRotation(offset: number) {
        return offset
    }

    @Action({ commit: 'SET_CENTER' })
    public SetCenter(center: [number, number]) {
        return center
    }

    @Action
    public Deselect() {
    }

    @Action({ commit: 'SET_DEACTIVATED' })
    public SetDeactivated(deactivated: number) {
        return deactivated
    }

    @Action({ commit: 'INITIALIZE_TOOLBAR' })
    public Initialize(payload: ToolbarInitializePayload) {
        return payload
    }

    @Action({ commit: 'SET_CONFIRMED' })
    public SetConfirmed(confirmed: boolean) {
        return confirmed
    }

    @Action({ commit: 'SET_USAGENAME' })
    public SetErrorKey(usagename: string) {
        return usagename
    }

    @Action({ commit: 'UNSET_USAGENAME' })
    public UnsetErrorKey(usagename: string) {
        return usagename
    }
}

export const ToolbarModule = getModule(Toolbar)